/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_404_CtaInputs */

const en_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go home`)
};

const es_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al inicio`)
};

const de_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Hause gehen`)
};

const zh_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回首页`)
};

const ar_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العودة للرئيسية`)
};

const fr_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rentre chez toi`)
};

const vi_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về trang chủ`)
};

const sw_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenda nyumbani`)
};

const th_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กลับหน้าแรก`)
};

const bs_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na početnu`)
};

const ja_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホーム`)
};

const ko_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`홈으로`)
};

const pt_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o início`)
};

const it_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai a casa.`)
};

const sv_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå hem`)
};

const nl_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar huis.`)
};

const da_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå hjem`)
};

const nb_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå hjem`)
};

const fi_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mene kotiin.`)
};

const pl_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idź do domu.`)
};

const ru_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Иди домой.`)
};

const tr_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eve git`)
};

const hi_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घर जाओ`)
};

const id_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulanglah`)
};

const ms_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ke laman utama`)
};

const cs_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jdi domů.`)
};

const el_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πήγαινε σπίτι.`)
};

const he_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לכו הביתה`)
};

const af_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaan na die tuisblad`)
};

const hu_error_404_cta = /** @type {(inputs: Error_404_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menj haza.`)
};

/**
* | output |
* | --- |
* | "Go home" |
*
* @param {Error_404_CtaInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const error_404_cta = /** @type {((inputs?: Error_404_CtaInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_404_CtaInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_error_404_cta(inputs)
	if (locale === "de") return de_error_404_cta(inputs)
	if (locale === "zh") return zh_error_404_cta(inputs)
	if (locale === "ar") return ar_error_404_cta(inputs)
	if (locale === "fr") return fr_error_404_cta(inputs)
	if (locale === "vi") return vi_error_404_cta(inputs)
	if (locale === "sw") return sw_error_404_cta(inputs)
	if (locale === "th") return th_error_404_cta(inputs)
	if (locale === "bs") return bs_error_404_cta(inputs)
	if (locale === "ja") return ja_error_404_cta(inputs)
	if (locale === "ko") return ko_error_404_cta(inputs)
	if (locale === "pt") return pt_error_404_cta(inputs)
	if (locale === "it") return it_error_404_cta(inputs)
	if (locale === "sv") return sv_error_404_cta(inputs)
	if (locale === "nl") return nl_error_404_cta(inputs)
	if (locale === "da") return da_error_404_cta(inputs)
	if (locale === "nb") return nb_error_404_cta(inputs)
	if (locale === "fi") return fi_error_404_cta(inputs)
	if (locale === "pl") return pl_error_404_cta(inputs)
	if (locale === "ru") return ru_error_404_cta(inputs)
	if (locale === "tr") return tr_error_404_cta(inputs)
	if (locale === "hi") return hi_error_404_cta(inputs)
	if (locale === "id") return id_error_404_cta(inputs)
	if (locale === "ms") return ms_error_404_cta(inputs)
	if (locale === "cs") return cs_error_404_cta(inputs)
	if (locale === "el") return el_error_404_cta(inputs)
	if (locale === "he") return he_error_404_cta(inputs)
	if (locale === "af") return af_error_404_cta(inputs)
	if (locale === "hu") return hu_error_404_cta(inputs)
	return en_error_404_cta(inputs)
});